(() => {
  const cartMarkup = '<strong>Quick double-check:</strong> If you chose a numbered nurse design, make sure the selected number matches the photo before checkout.';

  function replaceCheckoutControl() {
    const button = document.querySelector('#cart-drawer #checkout, #cart-drawer .cart__checkout-button');
    if (!button || button.matches('a[data-jazz-checkout-link]')) return;
    const link = document.createElement('a');
    link.href = '/checkout';
    link.className = button.className;
    link.id = 'checkout';
    link.setAttribute('data-jazz-checkout-link', 'true');
    link.setAttribute('role', 'button');
    link.innerHTML = button.innerHTML;
    button.replaceWith(link);
  }

  function updateHomepageStory() {
    const section = document.querySelector('#MainContent[data-template="index"] > [id$="__section_9HeyGM"]');
    if (!section || section.dataset.jazzStoryUpdated === '1') return;
    const textBlock = section.querySelector('.text-block, rte-formatter, [class*="text-block"]');
    if (!textBlock) return;
    const richText = textBlock.querySelector('rte-formatter, .rte, .text-block__content') || textBlock;
    richText.innerHTML = '<h3>Made by a Nurse Who Gets It.</h3><p>Hi, I\'m Karen — nurse, small business owner, and the maker behind Jazz & Co.</p><p>I started creating badge reels and shift-friendly accessories because healthcare workers deserve gear that feels practical, personal, and a little more fun.</p><p>Everything here is designed with real shifts, real personalities, and real healthcare workers in mind — because I’m one too.</p>';
    section.dataset.jazzStoryUpdated = '1';
  }

  function refreshBtsSection() {
    const section = document.querySelector('#MainContent[data-template="index"] > [id$="__section_aptNif"]');
    if (!section || section.dataset.jazzBtsUpdated === '1') return;
    const video = section.querySelector('video, iframe, deferred-media, [class*="video"]');
    if (video) {
      const videoBlock = video.closest('.group-block, .video-block, [class*="video"]') || video;
      videoBlock.style.display = 'none';
    }
    const textBlocks = Array.from(section.querySelectorAll('.text-block, rte-formatter, [class*="text-block"]'));
    const textBlock = textBlocks.find((el) => /behind the scenes|product launch|youtube/i.test(el.textContent || '')) || textBlocks[0];
    if (textBlock) {
      const richText = textBlock.querySelector('rte-formatter, .rte, .text-block__content') || textBlock;
      richText.innerHTML = '<h3>Behind the Scenes at Jazz & Co.</h3><p>Come hang out for new designs, packing days, product drops, and the real-life chaos behind a nurse-owned small business.</p><p><a href="https://www.youtube.com/@jazzcocreations" target="_blank" rel="noopener">Watch on YouTube →</a></p>';
    }
    section.dataset.jazzBtsUpdated = '1';
  }

  function reorderProductPurchaseFlow() {
    const detailsContent = document.querySelector('.product-details > .group-block > .group-block-content');
    if (!detailsContent) return;
    const children = Array.from(detailsContent.children);
    const headerGroup = children.find((el) => el.querySelector('h1') && el.querySelector('variant-picker'));
    if (!headerGroup) return;
    const reviewBlock = children.find((el) => el !== headerGroup && el.querySelector('.jdgm-preview-badge, [class*="jdgm"]'));
    const buyBlock = children.find((el) => el !== headerGroup && el.querySelector('.buy-buttons-block, product-form-component'));

    if (detailsContent.firstElementChild !== headerGroup) detailsContent.prepend(headerGroup);

    const headerContent = headerGroup.querySelector('.group-block-content');
    if (headerContent) {
      const headerChildren = Array.from(headerContent.children);
      const titleBlock = headerChildren.find((el) => el.querySelector('h1'));
      const variantBlock = headerChildren.find((el) => el.querySelector('variant-picker'));
      const priceBlock = headerChildren.find((el) => el !== titleBlock && el !== variantBlock && (el.matches('[class*="price"]') || el.querySelector('.price, [class*="price"]')));

      if (titleBlock && headerContent.firstElementChild !== titleBlock) headerContent.prepend(titleBlock);
      if (priceBlock) {
        const priceAnchor = titleBlock || headerContent.firstElementChild;
        if (priceAnchor && priceAnchor.nextElementSibling !== priceBlock) priceAnchor.after(priceBlock);
      }
      if (variantBlock) {
        const variantAnchor = priceBlock || titleBlock || headerContent.firstElementChild;
        if (variantAnchor && variantAnchor.nextElementSibling !== variantBlock) variantAnchor.after(variantBlock);
      }
    }

    if (reviewBlock && headerGroup.nextElementSibling !== reviewBlock) headerGroup.after(reviewBlock);
    const buyAnchor = reviewBlock || headerGroup;
    if (buyBlock && buyAnchor.nextElementSibling !== buyBlock) buyAnchor.after(buyBlock);
  }

  function addVariantHelper() {
    const picker = document.querySelector('#MainContent[data-template^="product"] variant-picker');
    if (!picker || picker.parentElement?.querySelector('.jazz-variant-helper')) return;
    const values = Array.from(picker.querySelectorAll('option, input[type="radio"]')).map((el) => (el.value || '').trim()).filter(Boolean);
    if (!values.length) return;
    const numericCount = values.filter((value) => /^\d{1,2}$/.test(value)).length;
    if (numericCount < Math.max(2, Math.ceil(values.length * .5))) return;
    const helper = document.createElement('div');
    helper.className = 'jazz-variant-helper';
    helper.innerHTML = '<strong>Choose your nurse:</strong> Swipe through the photos, find the design number you want, then select that same number below.';
    picker.before(helper);
  }

  function addProductReassurance() {
    const detailsContent = document.querySelector('.product-details > .group-block > .group-block-content');
    if (!detailsContent || detailsContent.querySelector('.jazz-product-reassurance')) return;
    const buyBlock = Array.from(detailsContent.children).find((el) => el.querySelector('.buy-buttons-block, product-form-component'));
    if (!buyBlock) return;
    const title = (document.querySelector('#MainContent[data-template^="product"] h1')?.textContent || '').toLowerCase();
    const isTumbler = title.includes('tumbler');
    const isBadgeReel = title.includes('badge reel') || title.includes('badge holder');
    const box = document.createElement('div');
    box.className = 'jazz-product-reassurance';
    box.innerHTML = `<div><strong>🚚 Turnaround:</strong> ${isTumbler ? 'Tumblers have a separate turnaround time listed in the product details.' : 'Most items are processed and ship within 5–7 business days.'}</div><div><strong>📦 Free shipping:</strong> Orders $50+.</div><div><strong>✉️ Tracking:</strong> Sent to your checkout email when your order ships.</div>${isBadgeReel ? '<div><strong>🛡️ Badge reel warranty:</strong> 90 days.</div>' : ''}`;
    buyBlock.after(box);
  }

  function cleanProductPage() {
    const main = document.querySelector('#MainContent[data-template^="product"]');
    if (!main) return;
    main.querySelectorAll('.shopify-section').forEach((section) => {
      const text = (section.textContent || '').replace(/\s+/g, ' ').trim();
      if (/Ships in 5-7 business days/i.test(text) && !section.querySelector('.product-details')) section.classList.add('jazz-hide-stale-turnaround');
    });
  }

  function addCartReminder() {
    const cartSummary = document.querySelector('.cart-summary__inner, #cart-drawer .cart-drawer__summary, #cart-drawer [class*="summary"]');
    if (cartSummary && !cartSummary.querySelector('.jazz-cart-number-check')) {
      const reminder = document.createElement('div');
      reminder.className = 'jazz-cart-number-check';
      reminder.innerHTML = cartMarkup;
      cartSummary.append(reminder);
    }
  }

  function setupMotion() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const hero = document.querySelector('[id$="__hero_XTUyVh"] .hero__content-wrapper');
    if (hero && !hero.classList.contains('jazz-hero-enter')) hero.classList.add('jazz-hero-enter');
    if (!window.__jazzRevealObserver) {
      window.__jazzRevealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: .1, rootMargin: '0px 0px -4% 0px' });
    }
    const targets = [...document.querySelectorAll('#MainContent[data-template="index"] > .shopify-section'), ...document.querySelectorAll('#MainContent[data-template="index"] .product-card'), ...document.querySelectorAll('#MainContent[data-template^="product"] .product-details > *')];
    let cardIndex = 0;
    targets.forEach((el) => {
      if (el.dataset.jazzMotion === '1' || el.closest('[id$="__hero_XTUyVh"]')) return;
      el.dataset.jazzMotion = '1';
      el.classList.add('jazz-reveal');
      if (el.classList.contains('product-card')) { el.style.setProperty('--jazz-delay', `${(cardIndex % 4) * 65}ms`); cardIndex += 1; }
      window.__jazzRevealObserver.observe(el);
    });
  }

  function improveSpecialtyShopping() {
    const section = document.querySelector('#MainContent[data-template="index"] > [id$="__product_list_pyK8mF"]');
    if (!section) return;
    const heading = section.querySelector('h2, h3, h4');
    if (heading) {
      heading.textContent = 'Shop by Specialty';
      const headingWrap = heading.parentElement;
      if (headingWrap && !headingWrap.querySelector('.jazz-specialty-subtext')) {
        const subtext = document.createElement('p');
        subtext.className = 'jazz-specialty-subtext';
        subtext.textContent = 'Find badge reels and accessories made for your corner of healthcare.';
        heading.insertAdjacentElement('afterend', subtext);
      }
    }
    const button = Array.from(section.querySelectorAll('a')).find((a) => /see all/i.test(a.textContent || ''));
    if (button) { button.textContent = 'Shop All Specialties'; button.href = '/collections/shop-by-profession'; }
  }

  function addSaleCallout() {
    const main = document.querySelector('#MainContent[data-template="index"]');
    if (!main || main.querySelector('.jazz-sale-callout-section')) return;
    const section = document.createElement('section');
    section.className = 'jazz-sale-callout-section';
    section.setAttribute('aria-labelledby', 'jazz-sale-title');
    section.innerHTML = `<div class="jazz-sale-callout"><div><p class="jazz-sale-eyebrow">A LITTLE TREAT</p><h2 id="jazz-sale-title">Grab a deal before your shift does.</h2><p>Clearance favorites, limited quantities, no code needed.</p></div><a class="button" href="/collections/summer-clearance-sale">Shop the Sale</a></div>`;
    main.append(section);
  }

  function addConversionFAQ() {
    const main = document.querySelector('#MainContent[data-template="index"]');
    if (!main || main.querySelector('.jazz-conversion-faq')) return;
    const section = document.createElement('section');
    section.className = 'jazz-conversion-faq';
    section.setAttribute('aria-labelledby', 'jazz-faq-title');
    section.innerHTML = `<div class="jazz-conversion-faq__inner"><p class="jazz-sale-eyebrow">QUICK ANSWERS</p><h2 id="jazz-faq-title">Before you ask your charge nurse…</h2><div class="jazz-faq-grid"><details><summary>How long does my order take?</summary><div class="jazz-faq-answer"><p>Most items are processed in 5–7 business days. Tumblers have their own turnaround listed on the product page.</p></div></details><details><summary>Do you offer free shipping?</summary><div class="jazz-faq-answer"><p>Yep — orders $50+ qualify for free shipping.</p></div></details><details><summary>Will I get tracking?</summary><div class="jazz-faq-answer"><p>Yes. Tracking is sent to the email used at checkout when your order ships. Carrier updates can take a little time to appear.</p></div></details><details><summary>How do the numbered nurse designs work?</summary><div class="jazz-faq-answer"><p>Swipe through the product photos, find the design number you want, then select that same number from the product options before adding it to your cart.</p></div></details><details><summary>Who makes these products?</summary><div class="jazz-faq-answer"><p>Jazz & Co. Creations is nurse-owned, and the shop is built around fun accessories made for real healthcare shifts.</p></div></details></div></div>`;
    main.append(section);
  }

  function cleanHomepageLinks() {
    const section = document.querySelector('#MainContent[data-template="index"] > [id$="__product_list_fa6P9H"]');
    section?.querySelectorAll('a[target="_blank"]').forEach((link) => { link.removeAttribute('target'); link.removeAttribute('rel'); });
  }

  function applyEnhancements() {
    replaceCheckoutControl();
    updateHomepageStory();
    refreshBtsSection();
    reorderProductPurchaseFlow();
    addVariantHelper();
    addProductReassurance();
    cleanProductPage();
    addCartReminder();
    improveSpecialtyShopping();
    addSaleCallout();
    addConversionFAQ();
    cleanHomepageLinks();
    setupMotion();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyEnhancements, { once: true });
  else applyEnhancements();
  const observer = new MutationObserver(() => { clearTimeout(window.__jazzEnhancementTimer); window.__jazzEnhancementTimer = setTimeout(applyEnhancements, 90); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', applyEnhancements);
  document.addEventListener('shopify:block:select', applyEnhancements);
})();


/* Jazz variant-form sync: keep selected design and cart variant aligned. */
(() => {
  function syncVariantFromPicker(picker) {
    if (!(picker instanceof HTMLElement)) return;
    const select = picker.querySelector('select');
    if (!(select instanceof HTMLSelectElement)) return;
    const selected = select.options[select.selectedIndex];
    const variantId = selected?.dataset?.variantId;
    if (!variantId) return;

    const scope = picker.closest('.shopify-section') || document;
    scope.querySelectorAll('product-form-component input[name="id"]').forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      input.value = variantId;
      input.setAttribute('value', variantId);
    });
  }

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLSelectElement)) return;
    const picker = target.closest('variant-picker[data-template-product-match="true"]');
    if (!picker) return;
    syncVariantFromPicker(picker);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('product-form-component')) return;
    const section = form.closest('.shopify-section');
    const picker = section?.querySelector('variant-picker[data-template-product-match="true"]');
    if (picker) syncVariantFromPicker(picker);
  }, true);
})();


/* Jazz sold-out option cleanup: show only purchasable design numbers. */
(() => {
  function hideUnavailableOptions() {
    document
      .querySelectorAll('variant-picker[data-template-product-match="true"] select option')
      .forEach((option) => {
        if (!(option.textContent || '').includes('Unavailable')) return;
        option.remove();
      });

    document
      .querySelectorAll('variant-picker[data-template-product-match="true"] select')
      .forEach((select) => {
        if (!(select instanceof HTMLSelectElement)) return;
        const picker = select.closest('variant-picker');
        if (!picker || picker.parentElement?.querySelector('.jazz-available-designs-note')) return;
        const note = document.createElement('p');
        note.className = 'jazz-available-designs-note';
        note.textContent = 'Only currently available designs are shown.';
        select.parentElement?.insertAdjacentElement('afterend', note);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideUnavailableOptions, { once: true });
  } else {
    hideUnavailableOptions();
  }

  const soldOutObserver = new MutationObserver(() => {
    clearTimeout(window.__jazzSoldOutTimer);
    window.__jazzSoldOutTimer = setTimeout(hideUnavailableOptions, 60);
  });
  soldOutObserver.observe(document.documentElement, { childList: true, subtree: true });
})();


/* Jazz numeric variant buttons: reliable mobile selection without native picker. */
(() => {
  function buildNumericButtons() {
    document.querySelectorAll('variant-picker[data-template-product-match="true"] select').forEach((select) => {
      if (!(select instanceof HTMLSelectElement)) return;
      const options = Array.from(select.options);
      if (!options.length || options.filter((option) => /^\d+$/.test(option.value.trim())).length < options.length * 0.8) return;

      const existing = select.parentElement?.querySelector('.jazz-number-buttons');
      if (existing) {
        existing.querySelectorAll('button').forEach((button) => {
          button.classList.toggle('is-selected', button.dataset.value === select.value);
          button.setAttribute('aria-pressed', button.dataset.value === select.value ? 'true' : 'false');
        });
        return;
      }

      select.classList.add('jazz-native-select-hidden');
      const group = document.createElement('div');
      group.className = 'jazz-number-buttons';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', 'Choose an available design number');

      options.forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'jazz-number-button';
        button.dataset.value = option.value;
        button.textContent = option.value;
        button.setAttribute('aria-pressed', option.value === select.value ? 'true' : 'false');
        if (option.value === select.value) button.classList.add('is-selected');
        group.append(button);
      });

      select.insertAdjacentElement('afterend', group);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.jazz-number-button');
    if (!(button instanceof HTMLButtonElement)) return;
    const group = button.closest('.jazz-number-buttons');
    const select = group?.parentElement?.querySelector('select');
    if (!(select instanceof HTMLSelectElement)) return;

    const layoutAnchor = select.closest('variant-picker')?.parentElement;
    if (layoutAnchor instanceof HTMLElement) {
      const lockedHeight = Math.ceil(layoutAnchor.getBoundingClientRect().height);
      layoutAnchor.style.minHeight = `${lockedHeight}px`;
      setTimeout(() => { layoutAnchor.style.minHeight = ''; }, 1800);
    }

    select.value = button.dataset.value || '';
    const selected = select.options[select.selectedIndex];
    const variantId = selected?.dataset?.variantId;
    const scope = select.closest('.shopify-section') || document;

    if (variantId) {
      scope.querySelectorAll('product-form-component input[name="id"]').forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;
        input.value = variantId;
        input.setAttribute('value', variantId);
      });
    }

    group.querySelectorAll('.jazz-number-button').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-selected', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    select.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  function initialize() {
    buildNumericButtons();
    const observer = new MutationObserver(() => {
      clearTimeout(window.__jazzNumberButtonsTimer);
      window.__jazzNumberButtonsTimer = setTimeout(buildNumericButtons, 70);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();


/* Jazz text variant buttons: product options without dropdowns. */
(() => {
  function buildTextButtons() {
    document.querySelectorAll('variant-picker[data-template-product-match="true"] select').forEach((select) => {
      if (!(select instanceof HTMLSelectElement)) return;
      const options = Array.from(select.options);
      if (!options.length || options.filter((option) => /^\d+$/.test(option.value.trim())).length >= options.length * 0.8) return;

      const existing = select.parentElement?.querySelector('.jazz-text-buttons');
      if (existing) {
        existing.querySelectorAll('button').forEach((button) => {
          const active = button.dataset.value === select.value;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        return;
      }

      select.classList.add('jazz-native-select-hidden');
      const group = document.createElement('div');
      group.className = 'jazz-text-buttons';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', select.getAttribute('aria-label') || select.name || 'Choose an option');

      options.forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'jazz-text-button';
        button.dataset.value = option.value;
        button.textContent = option.textContent?.trim() || option.value;
        button.setAttribute('aria-pressed', option.value === select.value ? 'true' : 'false');
        if (option.value === select.value) button.classList.add('is-selected');
        group.append(button);
      });

      select.insertAdjacentElement('afterend', group);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.jazz-text-button');
    if (!(button instanceof HTMLButtonElement)) return;
    const group = button.closest('.jazz-text-buttons');
    const select = group?.parentElement?.querySelector('select');
    if (!(select instanceof HTMLSelectElement)) return;

    const layoutAnchor = select.closest('variant-picker')?.parentElement;
    if (layoutAnchor instanceof HTMLElement) {
      const lockedHeight = Math.ceil(layoutAnchor.getBoundingClientRect().height);
      layoutAnchor.style.minHeight = `${lockedHeight}px`;
      setTimeout(() => { layoutAnchor.style.minHeight = ''; }, 1800);
    }

    select.value = button.dataset.value || '';
    const selected = select.options[select.selectedIndex];
    const variantId = selected?.dataset?.variantId;
    const scope = select.closest('.shopify-section') || document;

    if (variantId) {
      scope.querySelectorAll('product-form-component input[name="id"]').forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;
        input.value = variantId;
        input.setAttribute('value', variantId);
      });
    }

    group.querySelectorAll('.jazz-text-button').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-selected', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    select.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  function initialize() {
    buildTextButtons();
    const observer = new MutationObserver(() => {
      clearTimeout(window.__jazzTextButtonsTimer);
      window.__jazzTextButtonsTimer = setTimeout(buildTextButtons, 70);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();


/* Jazz resolved-combination sync: multi-option products. */
(() => {
  function syncResolvedCombination() {
    document.querySelectorAll('variant-picker[data-template-product-match="true"]').forEach((picker) => {
      const selects = Array.from(picker.querySelectorAll('select'));
      if (!selects.length) return;
      const selectedOptions = selects.map((select) => select.options[select.selectedIndex]).filter(Boolean);
      const variantIds = selectedOptions.map((option) => option.dataset?.variantId).filter(Boolean);
      if (!variantIds.length) return;
      const variantId = variantIds[variantIds.length - 1];
      const scope = picker.closest('.shopify-section') || document;
      scope.querySelectorAll('product-form-component input[name="id"]').forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;
        input.value = variantId;
        input.setAttribute('value', variantId);
      });
    });
  }

  document.addEventListener('change', (event) => {
    if (!event.target.closest?.('variant-picker[data-template-product-match="true"]')) return;
    [0, 150, 450, 900, 1500].forEach((delay) => setTimeout(syncResolvedCombination, delay));
  }, true);

  document.addEventListener('submit', (event) => {
    if (!event.target.closest?.('product-form-component')) return;
    syncResolvedCombination();
  }, true);

  const combinationObserver = new MutationObserver(() => {
    clearTimeout(window.__jazzCombinationTimer);
    window.__jazzCombinationTimer = setTimeout(syncResolvedCombination, 90);
  });
  combinationObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
